// Phase 21 · Room card (audio/video badge)
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radio, Video, Users, Mic } from "lucide-react";

export default function RoomCard({ room }) {
    const isAudio = room.room_type === "audio";
    const isLive = room.status === "live";
    const url = `/rooms/${isAudio ? "audio" : "video"}/${room.slug || room.id}`;

    return (
        <Link
            to={url}
            data-testid={`room-card-${room.slug || room.id}`}
            className="group block relative bg-[#111111] border border-[#1A1A1A] rounded-2xl overflow-hidden hover:border-[#FFFFFF]/50 transition-all"
        >
            <div className={`h-20 relative overflow-hidden ${isAudio ? "bg-gradient-to-br from-[#FFFFFF]/15 to-[#CCCCCC]/15" : "bg-gradient-to-br from-[#FAFAFA]/15 to-[#A3A3A3]/15"}`}>
                <div className="absolute inset-0 flex items-center justify-center">
                    {isAudio
                        ? <Mic size={30} className="text-[#FFFFFF]" />
                        : <Video size={30} className="text-[#FAFAFA]" />}
                </div>
                <div className={`absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-1 rounded-full border text-[10px] font-bold uppercase tracking-widest ${isAudio ? "bg-[#FFFFFF]/20 border-[#FFFFFF]/40 text-[#FFFFFF]" : "bg-[#FAFAFA]/20 border-[#FAFAFA]/40 text-[#FAFAFA]"}`}>
                    {isAudio ? "AUDIO" : "VIDEO"}
                </div>
                {isLive && (
                    <div className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#FAFAFA] text-white text-[10px] font-bold uppercase tracking-widest animate-pulse">
                        <Radio size={9} /> LIVE
                    </div>
                )}
            </div>
            <div className="p-3">
                <h3 className="text-sm font-semibold text-neutral-100 group-hover:text-[#FFFFFF] line-clamp-2">
                    {room.title}
                </h3>
                <div className="flex items-center gap-3 text-[11px] text-neutral-500 mt-1.5">
                    <span className="inline-flex items-center gap-1">
                        <Users size={11} /> {room.participant_count || 0}
                    </span>
                    {isAudio && (
                        <span className="inline-flex items-center gap-1">
                            <Mic size={11} /> {room.speaker_count || 0}/{room.max_speakers || 8}
                        </span>
                    )}
                </div>
                <div className="flex items-center gap-2 mt-2">
                    <div className="w-5 h-5 rounded-full bg-white flex items-center justify-center text-neutral-900 text-[10px] font-bold">
                        {room.host_username?.[0]?.toUpperCase() || "?"}
                    </div>
                    <span className="text-[11px] text-neutral-400">@{room.host_username}</span>
                    {room.viewer_role && (
                        <span className="ml-auto text-[10px] px-2 py-0.5 rounded-full bg-[#CCCCCC]/10 border border-[#CCCCCC]/40 text-[#CCCCCC] font-semibold capitalize">
                            {room.viewer_role}
                        </span>
                    )}
                </div>
            </div>
        </Link>
    );
}
